module.exports = __webpack_public_path__ + "img/SketchPng81934d078e0861ba65475c5a2827058029530b1e82fb695468c7b3cf793d1391.9e375bdc.png";